import { getOr } from 'lodash/fp';
import { MAKE_OTHER_VALUE } from 'helpers/fieldOptions/car/make';
import { loadModel, loadSubType } from '../duck';

const isValidMake = (make) => make && make !== MAKE_OTHER_VALUE;

const maybeLoadModel = (make) =>
  function* ({ getState }) {
    const { isLoaded, isLoading } = getOr({}, ['vehicle', 'model', make])(
      getState(),
    );

    if (isValidMake(make) && !isLoaded && !isLoading) {
      yield loadModel(make);
    }
  };

const maybeLoadSubType = (make) =>
  function* ({ getState }) {
    const { isLoaded, isLoading } = getOr({}, ['vehicle', 'subType', make])(
      getState(),
    );

    if (isValidMake(make) && !isLoaded && !isLoading) {
      yield loadSubType(make);
    }
  };

export const maybeLoadModelSubType = (make) =>
  function* () {
    yield [maybeLoadModel(make), maybeLoadSubType(make)];
  };
